function FacebookIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
      <path
        d="M9.71723 20.6955V14.3741H7.7553V11.4689H9.71723V10.2173C9.71723 6.98154 11.1812 5.48329 14.3562 5.48329C14.9571 5.48329 15.995 5.60106 16.4211 5.71883V8.35041C16.1966 8.32771 15.8048 8.31609 15.322 8.31609C13.7631 8.31609 13.1621 8.90547 13.1621 10.4418V11.4689H16.269L15.7367 14.3735H13.1663V20.9062C17.873 20.3361 21.5199 16.3284 21.5199 11.4689C21.5199 6.21895 17.2638 1.96289 12.0138 1.96289C6.76388 1.96289 2.50781 6.21895 2.50781 11.4689C2.50781 15.9272 5.57649 19.6682 9.71723 20.6955Z"
        fill="currentColor"
        fillOpacity="0.65"
      />
    </svg>
  );
}
export default FacebookIcon;
